import { Component, OnInit, Input, ViewChild, TemplateRef, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';



@Component({
  selector: 'data-note',
  templateUrl: './data-note.html',
  styleUrls: ['./data-note.css']
})
export class DataNote {
  constructor(private route: ActivatedRoute) { }
}



// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/data-note/data-note.ts